import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[480px] md:min-h-[520px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Lifestyle%20editorial%20photography%20of%20a%20diverse%20friend%20group%20walking%20through%20a%20sun%20drenched%20city%20street%20in%20golden%20hour%20light%2C%20wearing%20stylish%20casual%20streetwear%20outfits%2C%20warm%20amber%20and%20honey%20tones%20reflecting%20off%20modern%20glass%20buildings%2C%20natural%20candid%20moment%20capturing%20authentic%20joy%20and%20connection%2C%20contemporary%20urban%20fashion%20aesthetic%2C%20soft%20lens%20flare%20and%20warm%20atmospheric%20haze%2C%20aspirational%20city%20lifestyle%20magazine%20cover%20quality%2C%20inclusive%20and%20energetic%20composition&width=1600&height=900&seq=cta-bg-2026-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet - znajdź produkty"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-heading font-extrabold text-white mb-4 leading-tight">
          {t("cta.title")}
        </h2>
        <p className="text-white/80 text-sm md:text-lg mb-8 max-w-xl mx-auto leading-relaxed">
          {t("cta.subtitle")}
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-10 py-4 bg-foreground-950 text-white rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500">
            <i className="ri-shopping-bag-line text-white text-sm"></i>
          </span>
          {t("cta.button")}
          <i className="ri-arrow-right-up-line text-white/70"></i>
        </a>
      </div>
    </section>
  );
}